const EventBus = window.EventBus;
export const NewToggleListAbsoluteAdvancedHover = {
  template: `
    <div class="relative search-dropdown">
    <div v-if="disabled" class="absolute top-0 bottom-0 left-0 right-0 bg-secondary-light opacity-75 search-dropdown-content"></div>
      <transition name="fade">
      <div @click.stop="" :class="isResponsive ? 'lg:absolute' : ''" class="p-3 w-full z-50 bg-white border border-secondary-light h-auto max-h-[200px] overflow-y-auto">
        <div v-for="item in items">
          <label class="custom-checkbox text-left">
            {{$t(item)}} <small>{{getCount(item)}}</small>
            <input
              @change="toggle(component, item)"
              :key="item" 
              type="checkbox"
              :value="item"
              :name="item"
              :checked="selected.includes(item)">
            <span class="checkmark"></span>
          </label>
        </div>
      </div>
      </transition>
    </div>
  `,
  data: function () {
    return {
      show: false,
      uniqueInList: null,
      theme_directory: window.theme_directory,
      selected: [],
      loaded: false,
      enable: true,
    }
  },
  props: [
    'component',
    'title',
    'items',
    'initialSelection',
    'collapse',
    'pivot',
    'disable-responsive',
    'optionsCount'
  ],
  created(){
   
  },
  mounted(){
    EventBus.$on('CLOSE_ALL_OPEN_COMPONENTS', () => {
      if(this.show)
        this.show = false
    });
    EventBus.$on('CLEAR_ALL_NEW_TOGGLE_LIST_ABSOLUTE_ADVANCED_SELECTION', () => {
      this.clearSelection();
    })
    EventBus.$on('NEW_TOGGLE_LIST_ABSOLUTE_ENTRY_POINT', () => {
    })
  },
  methods: {
    entryPoint(items){
      this.selected = items.filter(i => {
        if(this.initialSelection.includes(i.replace(/ /g, '-').replace(/---/g, '-').toLowerCase()))
          return i;
      })
      this.$emit('updatechecked', {
        component: this.component,
        selected: this.selected,
      })
    },
    clearSelection() {
      this.selected = [];
      this.$emit('updatechecked', {
        component: this.component,
        selected: this.selected,
      })
    },
    display() {
      if(!this.hasItems() || !this.enable)
        return;
      this.show = !this.show;
    },
    hasItems(){
      return this.items.length > 0;
    },
    toggle(component, item) {
      var enabled = true;
      if(this.selected.includes(item)){
        this.selected.splice(this.selected.indexOf(item), 1);
        enabled = false
      }
      else
        this.selected.push(item);

      this.$emit('updatechecked', {
        component,
        selected: this.selected,
      })

      this.$emit('updatetags', {
        component,
        selected: item,
        status: enabled
      })
    },
    getCount(item){
      if(this.optionsCount && this.optionsCount[item])
        return `(${this.optionsCount[item]})`
      else
        return ""
    }
  },
  watch:{
    items(items){
      if(!this.loaded)
      {
        this.entryPoint(items);
        this.loaded = true;
      }
    }
  },  
  computed: {
    disabled(){
      return !this.hasItems() || !this.enable;
    },
    displayName(){
      if(this.selected.length == 0)
        return this.title;
      else
        if(this.selected.length > 2)
          return `${this.selected.slice(0, 2).join(',')}...`;
        else
          return this.selected.join(',');
    },
    isResponsive(){
      return !this.disableResponsive == true;
    }
  }
}